import { Clock, Mail, MapPin, Check } from "lucide-react";
import { Seo, Breadcrumbs, breadcrumbSchema } from "@/components/Seo";
import { Reveal, SectionTag } from "@/components/Motion";
import { ChatButton } from "@/components/Cta";

const CRUMBS = [{ name: "首页", path: "/" }, { name: "联系我们", path: "/contact" }];

const TOPICS = [
  "TikTok Shop 开店",
  "商品优化",
  "店铺运营",
  "内容规划",
  "电商日常运营",
];

export default function Contact() {
  return (
    <>
      <Seo
        title="联系 TKShopMY — WhatsApp 咨询"
        description="直接通过 WhatsApp 联系 TKShopMY 团队，咨询 TikTok Shop 开店、店铺运营、商品优化和电商日常运营问题。无需填写表格，直接对话。"
        path="/contact"
        schemas={[breadcrumbSchema(CRUMBS)]}
      />
      <section className="relative overflow-hidden pt-28 md:pt-40 pb-20 md:pb-28 grain" data-testid="contact-hero">
        <div className="pointer-events-none absolute -left-24 top-24 h-80 w-80 rounded-full bg-lime/25 blur-3xl" />
        <div className="mx-auto grid max-w-6xl gap-14 px-5 md:px-8 lg:grid-cols-[1.1fr_0.9fr]">
          <Reveal>
            <Breadcrumbs items={CRUMBS} />
            <SectionTag>联系我们</SectionTag>
            <h1 className="font-display text-4xl font-medium leading-[1.15] text-balance sm:text-5xl">
              需要帮助？直接 WhatsApp 和 TKShopMY 聊聊。
            </h1>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-ink/65 md:text-lg">
              点击 WhatsApp 按钮，告诉我们你卖什么、目前在进行什么 —— 团队会接着跟进。
            </p>
            <p className="mt-4 text-sm font-medium text-ink/70">
              想了解开店、代运营、一件代发或无需囤货合作方式，都可以直接 WhatsApp 咨询。
            </p>
            <div className="mt-5">
              <ChatButton location="contact-page" variant="primary" testId="contact-chat-button">
                WhatsApp 咨询
              </ChatButton>
            </div>
            <p className="mt-4 text-sm text-ink/50">点击按钮，直接 WhatsApp 我们。</p>

            <div className="mt-10">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-moss">团队可以回答的问题包括</p>
              <ul className="mt-4 space-y-2.5">
                {TOPICS.map((t) => (
                  <li key={t} className="flex items-center gap-2.5 text-sm text-ink/70">
                    <Check size={15} className="text-moss" />
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="rounded-3xl bg-forest p-8 text-paper md:p-10">
              <h2 className="font-display text-2xl font-semibold">团队信息</h2>
              <div className="mt-7 space-y-6">
                <div className="flex gap-4">
                  <Clock size={19} className="mt-0.5 shrink-0 text-lime" />
                  <div>
                    <p className="text-sm font-semibold">营业时间</p>
                    <p className="mt-1 text-sm text-paper/65">周一至周六，9:00am – 6:00pm（马来西亚时间）</p>
                    <p className="mt-0.5 text-xs text-paper/45">非工作时间的消息会在下一个工作日回复。</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <Mail size={19} className="mt-0.5 shrink-0 text-lime" />
                  <div>
                    <p className="text-sm font-semibold">电邮</p>
                    <a href="mailto:hello@tkshopmy.com" className="mt-1 block text-sm text-paper/65 underline-offset-4 hover:text-lime hover:underline" data-testid="contact-email">
                      hello@tkshopmy.com
                    </a>
                  </div>
                </div>
                <div className="flex gap-4">
                  <MapPin size={19} className="mt-0.5 shrink-0 text-lime" />
                  <div>
                    <p className="text-sm font-semibold">服务地区</p>
                    <p className="mt-1 text-sm text-paper/65">马来西亚 —— 远程服务全国卖家</p>
                  </div>
                </div>
              </div>
              <div className="mt-8 rounded-2xl border border-paper/15 bg-paper/5 p-5">
                <p className="text-xs leading-relaxed text-paper/55">
                  联系最快的方式就是 WhatsApp。点击按钮，直接和顾问对话。
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
